import React from 'react';
import Helmet from 'react-helmet';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import config from '../../config/SiteConfig';
import Container from '../components/Container/Container';
import Typist from 'react-typist';
import styles from '../../node_modules/react-typist/dist/standalone/Typist.css';

const About = () => (
  <div className="container about-container">
    <Helmet title={`About | ${config.siteTitle}`} />
    <Header>
        <Typist 
        avgTypingSpeed={30}
        cursor={{ blink: true }}
        >
          <span>About </span>
        
        </Typist>
    </Header>  
    <Container text>
        <p>I'm a modern day technologist who graduated from UCSB (philosophy). I've worked in tech for the past 9 years 
        in various capacities (full-stack javascript developer, project manager, IT administrator, etc). I'm passionate about 
        problem-solving and building elegant solutions as well as collaborating on cross-functional teams and managing projects. 
        </p>
        <p>Additionally, I'm an active musician who is experienced in running small DIY campaigns. Given my passions and experience, 
        I'm very interested in the intersection of data, media, and marketing. Through my unique experience, I'm eager to bring 
        value to your team as either a technical project manager, product manager or engineer.</p>
    </Container>
    <Footer/>
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/pages/about.jsx